<template>
    <div class="dot-container" :class="{ small: props.size === 'small' }">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
    </div>
</template>

<script setup lang="ts">

const props = defineProps<{
    size?: 'small';
}>();

</script>

<style lang="scss" scoped>

.dot-container {
    display: flex;
    gap: var(--defaultSpacing);

    .dot {
        width: var(--defaultSpacing);
        height: 1rem;
        border-radius: 50%;
        background: var(--accentColour);
        animation: pulse 1s infinite ease-in-out;

        @media (prefers-reduced-motion: reduce) {
            animation: none;
        }

        &:nth-child(2) {
            animation-delay: 0.25s;
        }

        &:nth-child(3) {
            animation-delay: 0.5s;
        }
    }
}

.small {
    gap: var(--smallSpacing);
    .dot {
        height: 0.5rem;
        width: var(--smallSpacing);
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.25);
    }

    100% {
        transform: scale(1);
    }
}

</style>
